module.exports = __webpack_public_path__ + "img/readingtask5passage.d59ad2f1.png";